import "../styles/Header.css";
import banner from '../images/logos/bsc_halloween_logo.jpg';

function MyHeader() {
  return (
      <header className="App-header">
        <img src={banner} className="logo-image" alt="Boughton-Shields Creations Banner" />
      </header>
  );
}

export default MyHeader;